import { useCallback, useEffect, useState } from 'react';
import { templateService } from '../services/templateService';

function mapTagOption(tag) {
  if (!tag?.id) return null;
  return {
    id: tag.id,
    name: tag.name,
    label: tag.name,
    value: tag.id,
  };
}

export default function useTemplateTags(companyId) {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!companyId) {
      setTags([]);
      return [];
    }
    setLoading(true);
    try {
      const res = await templateService.getTemplateTags(companyId);
      const list = res?.data?.data?.results ?? res?.data?.results ?? [];
      const mapped = list.map(mapTagOption).filter(Boolean);
      setTags(mapped);
      return mapped;
    } catch {
      setTags([]);
      return [];
    } finally {
      setLoading(false);
    }
  }, [companyId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { tags, loading, refresh };
}

export { mapTagOption };
